<template>
  <section class="section-product-detail-page bg-grey">
    <div class="container">
      <div class="row m-0">
        <div class="col-12">
          <div class="content py-0">
            <h2 class="h2-caslon section-title page-title h2 text-center text-black f-44">Home Appliances</h2>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="section-product-detail-page bg-primary">
    <div class="container">
      <div class="page-content">

        <div class="content">
          <ContentsTextWithImage
            title="Home Appliances"
            image-url="/pages/products/industries/ha.jpg"
            :contents="[
              'Thailand is basement of many world renown brands from air conditioner, washing machine, refrigerator, electric fan, cooking appliances. Since this industry are moving toward smart appliances and high competition, materials to use are functional with reasonable cost as plastics make most of the products. We have been suppling plastics materials like PP, ABS, AS, PA6, PPE to the market. Example of home appliances that use our plastics',
            ]"
            is-reverse="true"
            is-white-content="true"
            is-content-small-text="true"
            left-width="45.805%"
            right-width="54.195%"
          />
        </div>
        
      </div>
    </div>
  </section>

  <section class="section-gallery bg-grey">

    <section class="section-product-detail-page">
      <div class="container page-container">
        <div class="row m-0">
          <div class="col-12">
            <div class="content">

              <div class="row m-0">
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/d-air.jpg" alt="Air conditioning">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Air conditioning</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/d-wash.jpg" alt="Washing machine">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Washing machine</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/d-robot.jpg" alt="Robot cleaner">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Robot cleaner</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-product-detail-page">
      <div class="container page-container">
        <div class="row m-0">
          <div class="col-12">
            <div class="content">

              <div class="row m-0">
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/d-washer.jpg" alt="Dish washer">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Dish washer</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/d-frid.jpg" alt="Refrigerator">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Refrigerator</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/d-coffee.jpg" alt="Coffee machine">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Coffee machine</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <div v-show="isMoreGalleryShow">
      <section class="section-product-detail-page">
        <div class="container page-container">
          <div class="row m-0">
            <div class="col-12">
              <div class="content">

                <div class="row m-0">
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/wp-content/uploads/2022/07/ha.jpg" alt="Home appliance product"
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Air fryer</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>

                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/wp-content/uploads/2022/07/ha.jpg" alt="Home appliance product"
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Vacuum cleaner</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/wp-content/uploads/2022/07/ha.jpg" alt="Home appliance product"
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Industrial washing machine</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section-product-detail-page">
        <div class="container page-container">
          <div class="row m-0">
            <div class="col-12">
              <div class="content">

                <div class="row m-0">
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/wp-content/uploads/2022/07/ha.jpg" alt="Home appliance product"
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Sewing machine</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>

                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/wp-content/uploads/2022/07/ha.jpg" alt="Home appliance product"
                        </a>
                      </div>
                      <div class="card-content text-center">
                        <a href="#" class="card-title f-21">Water heater</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <section class="section-product-detail-page pt-4">
      <div class="container page-container">
        <div class="content text-center">
          <button
            class="btn btn-link text-primary text-decoration-none f-15 outline-none"
            @click="handleLoadmoreClick"
          >
            {{ loadMoreButtonText }}
          </button>
        </div>
      </div>
    </section>

  </section>
</template>
<script setup lang="ts">
useHead({
  title:'Home Appliances - NAGASE THAILAND Engineering Plastics',
})

const isMoreGalleryShow = useState<Boolean>('isMoreGalleryShow', () => false)
const loadMoreButtonText = useState<String>('loadMoreButtonText', () => 'Read More')

const handleLoadmoreClick = () => {
  isMoreGalleryShow.value = !isMoreGalleryShow.value
  loadMoreButtonText.value = isMoreGalleryShow.value ? 'Read Less' : 'Read More'
}
</script>

<style scoped>
.page-title {
  padding-bottom: 85px;
}

.section-gallery {
  padding-top: 60px;
  padding-bottom: 60px;
}
</style>